module.exports = __webpack_public_path__ + "img/isana-logo-1065x448.946a207c.jpg";